import ProjectCard from "./ProjectCard";
import portfolio from "./portfolio.json";
import "./PortfolioStyle.css";
import { Link } from "react-router-dom";
const PortfolioComponent = () => {
  return (
    <>
      {/* Hero Section */}
      <section className="hero-section bg-dark text-white py-5">
        <div className="container py-5">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="display-3 fw-bold mb-4 text-uppercase">
                Full Stack Developer
                {/* Hi, I'm <span className="text-primary">[Mahmoud Osman]</span> */}
              </h1>
              <p className="lead mb-4">
                Full Stack Developer passionate about building elegant solutions
                to complex problems
              </p>
              <div className="d-flex gap-3">
                <a
                  href="#projects"
                  className="btn btn-primary btn-lg px-4"
                  style={{ zIndex: 9999 }}
                >
                  View My Work <i className="fa fa-rocket ms-2"></i>
                </a>
                <Link
                  to="/api/get-in-touch/contact"
                  className="btn btn-outline-light btn-lg px-4"
                  style={{ zIndex: 9999 }}
                >
                  Contact Me
                </Link>
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block text-center">
              <i className="fa fa-laptop display-1 text-primary"></i>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="py-5 bg-light">
        <div className="container py-4">
          <div className="text-center mb-5">
            <h2 className="fw-bold display-5 mb-3">My Toolbox</h2>
            <p className="text-muted lead">Technologies I work with</p>
          </div>
          <div className="row g-4">
            {[
              {
                name: "Frontend",
                techs: [
                  "React",
                  "Angular",
                  "JavaScript",
                  "TypeScript",
                  "HTML5",
                  "CSS3",
                  "Bootstrap",
                ],
                icon: "fa-code",
              },
              {
                name: "Backend",
                techs: ["Node.js", "Express", "Java", "Spring Boot", "JPA"],
                icon: "fa-server",
              },
              {
                name: "Database",
                techs: ["MongoDB", "SQL", "PostgreSQL"],
                icon: "fa-database",
              },
              {
                name: "Tools",
                techs: ["Git", "GitHub", "Docker", "AWS"],
                icon: "fa-wrench",
              },
            ].map((category, index) => (
              <div className="col-md-3" key={index}>
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body text-center">
                    <div className="icon-wrapper bg-primary bg-opacity-10 text-primary rounded-circle p-3 mb-3 mx-auto">
                      <i className={`fa ${category.icon} fa-2x`}></i>
                    </div>
                    <h5 className="fw-bold mb-3">{category.name}</h5>
                    <div className="d-flex flex-wrap justify-content-center">
                      {category.techs.map((tech, i) => (
                        <span
                          key={i}
                          className="badge bg-white text-dark border m-1"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Projects Section */}
      <section className="py-5" id="projects">
        <div className="container py-4">
          <div className="text-center mb-5">
            <h2 className="fw-bold display-5 mb-3">Featured Projects</h2>
            <p className="text-muted lead">Some of my best work</p>
          </div>
          <div className="row g-4">
            {portfolio.projects.map((project, index) => (
              <ProjectCard
                key={index}
                id={project.id}
                title={project.title}
                description={project.description}
                image={project.image}
                url={project.url}
                githubUrl={project.githubUrl}
                technologies={project.technologies || []}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default PortfolioComponent;
